<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form>
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input class="w-full border p-2 rounded-md outline-none" placeholder="Search Quote" matInput
          (keyup)="applyFilter($event)" />
      </div>
      <div class="w-80">
        <select style="background: #4d4de6;"
          class="w-full p-2 outline-none bg-gradient-to-r from-primary to-semiPrimary border rounded-md text-white"
          (change)="onChangeActive($event)">
          <option value="">All</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
        </select>
      </div>

      <div class="w-60">
        <app-primary-button routerLink="//home/create-quote" class="flex w-40">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>Add Quote</span>
          </div>
        </app-primary-button>
      </div>
    </div>
  </form>

  <!-- Table -->
  <div class="bg-white rounded-2xl shadow-md p-4">
      <div class="overflow-x-auto">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 min-w-full">

      <!-- S.NO -->
      <ng-container matColumnDef="sno">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> S.NO </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let row"> {{ row.name }} </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
        <td mat-cell *matCellDef="let row"> {{ row.title }} </td>
      </ng-container>

      <ng-container matColumnDef="quoteStage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Stage </th>
        <td mat-cell *matCellDef="let row"> {{ row.quoteStage }} </td>
      </ng-container>

      <ng-container matColumnDef="contact">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Contact </th>
        <td mat-cell *matCellDef="let row"> {{ row.contact }} </td>
      </ng-container>

      <ng-container matColumnDef="account">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Account </th>
        <td mat-cell *matCellDef="let row"> {{ row.account }} </td>
      </ng-container>

      <ng-container matColumnDef="grandTotal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Grand Total </th>
        <td mat-cell *matCellDef="let row"> {{ row.grandTotal | currency }} </td>
      </ng-container>

      <ng-container matColumnDef="validUntil">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Valid Until </th>
        <td mat-cell *matCellDef="let row"> {{ row.validUntil | date: 'mediumDate' }} </td>
      </ng-container>

      <!-- Header and rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <app-empty-data *ngIf="dataSource.data.length < 1" class="justify-center align-items-center"
    [imageSource]="'../../assets/blankScreen/support.png'" [message]="'No data available'"></app-empty-data>
  <!-- Paginator -->
  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
  </div>

</div>
